<template>
  <div
    :key="uid"
    class="w-full pt-5 flex flex-col gap-2.5 items-center"
  >
    <div
      v-if="activeCategories.length"
      ref="scrollableCategoriesContainer"
      class="h-52 w-full flex flex-col divide-y divide-dashboard-grey"
      :class="{ 'overflow-y-auto': canSeeMoreRows, 'overflow-y-hidden': !canSeeMoreRows }"
    >
      <label
        v-for="({ category, commaSeparatedFormatEmissions, formattedEmissions, scopeBgColor }, index) in activeCategories"
        :key="index"
        :for="`asset-radio-${index}-${uid}`"
        class="w-full flex items-center justify-between py-1.5"
      >
        <div class="flex items-center gap-2.5">
          <div :class="`size-2 rotate-45 translate-x-1 ${scopeBgColor}`" />
          <span class="text-[#627285] text-sm">{{ category }}</span>
        </div>
        <div class="flex items-center gap-3">
          <CircleRoundedIcon
            v-if="selectedCategory === category"
            custom-style="w-5 h-5 text-white"
          />
          <input
            v-else
            :id="`asset-radio-${index}-${uid}`"
            v-model="selectedCategory"
            :value="category"
            category="categoriesBreakdownRadio"
            type="radio"
            class="p-1 rounded-full bg-slate-100 border-1 border-slate-100 text-main-primary focus:ring-transparent"
            @change="onCheckCategory(category)"
          >
          <span
            class="text-sm text-[#627285] w-[115px] text-right"
            :title="commaSeparatedFormatEmissions"
          >{{ formattedEmissions }} <span class="text-[#627285]/80 no-localize-translate">tCO<sub>2</sub>e</span></span>
        </div>
      </label>
    </div>
    <button
      v-if="activeCategories.length > 6"
      type="button"
      class="outline-none text-sm text-[#0574B6]"
      @click="toggleViewableCategories"
    >
      {{ canSeeMoreRows ? 'View Less' : 'View More' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EmissionsBreakdownCategoriesSelector',

  props: {
    breakdown: {
      type: Array,
      required: true,
    },
  },

  emits: ['categorySelected'],

  data() {
    return {
      canSeeMoreRows: false,
      selectedCategory: null,
      chartKey: 0,
      selectedIndex: null,
      uid: null,
    }
  },

  computed: {
    activeCategories() {
      return this.transformCategories(this.breakdown)
    },
  },
  mounted() {
    this.uid = this.$.uid
  },
  methods: {
    onCheckCategory() {
      this.$emit(
        'categorySelected',
        this.activeCategories.find(({ category }) => category === this.selectedCategory),
      )
    },
    toggleViewableCategories() {
      if (this.canSeeMoreRows) {
        this.$refs.scrollableCategoriesContainer.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
      nextTick(() => {
        this.canSeeMoreRows = !this.canSeeMoreRows
      })
    },
    transformCategories(categories) {
      const units = [
        { value: 1e12, symbol: 'T' },
        { value: 1e9, symbol: 'B' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'K' },
      ]

      return categories.map((category) => {
        let formattedEmissions
        if (category.total_emissions < 1e3) {
          formattedEmissions = thousands(category.total_emissions, 2, true)
        }
        else {
          for (const unit of units) {
            if (category.total_emissions >= unit.value) {
              formattedEmissions = thousands((category.total_emissions / unit.value).toFixed(2), 2, true) + unit.symbol
              break
            }
          }
        }
        category.formattedEmissions = formattedEmissions
        category.commaSeparatedFormatEmissions = thousands(category.total_emissions, 2, true)
        category.scopeBgColor = this.getBgColor(category.scope)

        return category
      })
    },
    getBgColor(scope) {
      let color = ''

      switch (scope.toLowerCase()) {
        case 'scope 1':
          color = 'bg-[#FABE13]'
          break
        case 'scope 2':
          color = 'bg-[#216579]'
          break
        case 'scope 3':
          color = 'bg-[#204B6F]'
          break
      }

      return color
    },
  },
}
</script>
